import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
const now = new Date();
const formattedDate = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}`;



function DoctorAppointment() {
  const [appointments, setappointments] = useState([]);
  useEffect(() => {
    baseUrl
      .get("dashboard/dentistWiseAppointments")
      .then((response) => {
        setappointments(response.data.result);

      
      })
      .catch((error) => {
        console.error(error.response);
      });
  }, []);
  return (
    <div className={"doctorWise"}>
      <div className={"headpart"}>
        <div className={"head"}>
          <p className={"mainTxt"}>Dentist Wise Appointments</p>
          <p className={"subTxt"}> / Today</p>
        </div>
        <p className={"dateTxt"}>{formattedDate}</p>
      </div>
      <div className={"detail"}>
        {appointments?.map((item: any, index: number) => (
          <div className={"col"} key={index}>
            <div className={"doctor_appoint"}>
              <p className={"nameTxt"}>
                {item?.firstName} {item?.lastName}
              </p>
              <div className={"detail"}>
                <p className={"numTxt"}>{item?.count}</p>
                <p className={"detTxt"}>
                  {item?.count == 1 ? "Appointment" : "Appointments"}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DoctorAppointment;
